import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const DeleteKitButton = ({ kit }) => {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try {
      await http.delete(`/kits/${kit.id}`);
      toast.success("Kit deleted");
      nav("/");
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button data-testid="delete-kit-button" title="Delete kit" className="inline-flex items-center gap-2 rounded-sm border border-red-500/30 px-3 py-2 text-sm text-red-400 hover:bg-red-500/10 transition-colors">
          <Trash2 size={15} />
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="delete-kit-dialog" className="bg-white text-[#2B2A26] border-stone-200">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this kit permanently?</AlertDialogTitle>
          <AlertDialogDescription>“{kit.destination}” and all its content will be removed. This cannot be undone.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-kit-cancel" className="bg-white">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-kit-confirm" disabled={busy} onClick={remove} className="bg-red-600 text-white hover:bg-red-700">Delete kit</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
